export default __webpack_public_path__ + "static/media/apple.253a07d0.svg";